<template>
<div class="cennert_bg">
    <div class="cennert_op"></div>
    <div class="index_cennert">
      <h2>线上展厅案例</h2>
      <div class="desc">360°无死角展示，拥有真实视觉体验</div>

<div data-aos="fade-up">
      <div class="cennert">
        <ul class="connert_left">
          <li 
            v-for="(item,index) in data" :key="index"
            @mouseover="mouseOver(index)"
            >
            <h4 :class="{Left_tip:img==index}">{{item.text}}</h4>
          </li>
        </ul>
        <div class="connert_right">
            <div class="connert_right_top">
                <div class="right_top_pop1" @click="changeName(data[img].link_[0])">
                     <img v-if="data[img].imag[0]" :src="data[img].imag[0]"/>
                    <div class="box_txt" v-if="data[img].text_h2[0]">
                        <p>{{data[img].text_h2[0]}}</p>
                    </div>
                </div>
                <div class="right_top_pop2"  @click="changeName(data[img].link_[1])">
                      <img v-if="data[img].imag[1]" :src="data[img].imag[1]"/>
                    <div class="box_txt" v-if="data[img].text_h2[1]">
                        <p>{{data[img].text_h2[1]}}</p>
                    </div>
                </div>
            </div>
            <div class="connert_right_bottom">
                <ul class="bottom_list">
                    <li  @click="changeName(data[img].link_[2])">
                        <img v-if="data[img].imag[2]" :src="data[img].imag[2]"/>
                         <div class="box_txt" v-if="data[img].text_h2[2]">
                            <p>{{data[img].text_h2[2]}}</p>
                          </div>
                    </li>
                    <li  @click="changeName(data[img].link_[3])">
                        <img v-if="data[img].imag[3]" :src="data[img].imag[3]"/>
                         <div class="box_txt" v-if="data[img].text_h2[3]">
                            <p>{{data[img].text_h2[3]}}</p>
                         </div>
                    </li>
                    <li   @click="changeName(data[img].link_[4])">
                        <img v-if="data[img].imag[4]" :src="data[img].imag[4]"/>
                         <div class="box_txt" v-if="data[img].text_h2[4]">
                            <p>{{data[img].text_h2[4]}}</p>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
        </div>
      </div>
      <div class="application">
          <h2>行业应用</h2>
          <div class="desc">场景营销体验必备，展示更多可能</div>
      </div>
      </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
              data:[
                {
                    text:"云创VR线上展厅",
                    imag:['','','','',''],
                    text_h2:["","","","",""],
                    link_:[
                            {
                                Model_link:10,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:10,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:10,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:10,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:10,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                        ]
                },
                {
                    text:"云创VR线上展位",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:8,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:8,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:8,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:8,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:8,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                        ]
                },
                {
                    text:"云创VR场景实拍",
                    imag:['','','','',''],
                    text_h2:["","","","",""],
                    link_:[     
                        {
                                Model_link:19,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:19,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:19,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:19,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:19,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                        ]
                },
                {
                    text:"云创VR党建文博",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:9,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:9,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:9,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:9,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:9,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                        ]
                },
                     {
                    text:"云创VR线上画展",
                    imag:['','','','',''],
                    text_h2:["","","",'',''],
                    link_:[     
                        {
                                Model_link:22,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:22,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:22,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:22,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                            {
                                Model_link:22,
                                codeid:'',
                                linkcmd:"",
                                bs:1,
                            },
                        ]
                }
                   ],
            img:1
        }
    },
    methods:{
        mouseOver(index){
            this.img = index
        },
    // 将我的数据传给父组件再由父组件传参给弹窗也就是cases.vue
        changeName(link_){
              if(link_.codeid == '' ){
                return false
            }else{
               
                if(link_.bs==1){
                    console.log(link_.linkcmd);
                    if(link_.linkcmd == null ||link_.linkcmd == ''){
                        console.log(link_.linkcmd);
                        return false
                    }else{
                        this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                    }
                }else{
                    console.log('45645665465');
                    this.$emit('handleChange', link_) // 触发父组件中handleChange事件并传参Jack
                }   
               
            }
        },
        // 线上展厅案例此处封装
        Exhibition_hall(cate2){
               this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetRandCateInfo",
                        this.$qs.stringify({
                             cate:10,      
                        }),    
                        )
                        .then(res => {   
                                    this.data[0].imag[0]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].img+'.'+res.data.data[0].type
                                    this.data[0].imag[1]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[1].img+'.'+res.data.data[1].type
                                    this.data[0].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
                                    this.data[0].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                                    this.data[0].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
                                    //文字
                                    this.data[0].text_h2[0] = res.data.data[0].title
                                    this.data[0].text_h2[1] = res.data.data[1].title
                                    this.data[0].text_h2[2] = res.data.data[2].title
                                    this.data[0].text_h2[3] = res.data.data[3].title
                                    this.data[0].text_h2[4] = res.data.data[4].title
                                    // id
                                    this.data[0].link_[0].codeid = res.data.data[0].ID
                                    this.data[0].link_[1].codeid = res.data.data[1].ID
                                    this.data[0].link_[2].codeid = res.data.data[2].ID
                                    this.data[0].link_[3].codeid = res.data.data[3].ID
                                    this.data[0].link_[4].codeid = res.data.data[4].ID
                                    //link
                                    this.data[0].link_[0].linkcmd = res.data.data[0].link
                                    this.data[0].link_[1].linkcmd = res.data.data[1].link
                                    this.data[0].link_[2].linkcmd = res.data.data[2].link
                                    this.data[0].link_[3].linkcmd = res.data.data[3].link
                                    this.data[0].link_[4].linkcmd = res.data.data[4].link
                                    this.img = 0


                        })
        },
        Booth(cate2){
                    this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetRandCateInfo",
                        this.$qs.stringify({
                             cate:8,
                        }),    
                        )
                        .then(res => {
                                    this.data[1].imag[0]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].img+'.'+res.data.data[0].type
                                    this.data[1].imag[1]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[1].img+'.'+res.data.data[1].type
                                    this.data[1].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
                                    this.data[1].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                                    this.data[1].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
                                    //文字
                                    this.data[1].text_h2[0] = res.data.data[0].title
                                    this.data[1].text_h2[1] = res.data.data[1].title
                                    this.data[1].text_h2[2] = res.data.data[2].title
                                    this.data[1].text_h2[3] = res.data.data[3].title
                                    this.data[1].text_h2[4] = res.data.data[4].title
                                    // id
                                    this.data[1].link_[0].codeid = res.data.data[0].ID
                                    this.data[1].link_[1].codeid = res.data.data[1].ID
                                    this.data[1].link_[2].codeid = res.data.data[2].ID
                                    this.data[1].link_[3].codeid = res.data.data[3].ID
                                    this.data[1].link_[4].codeid = res.data.data[4].ID
                                    //link
                                    this.data[1].link_[0].linkcmd = res.data.data[0].link
                                    this.data[1].link_[1].linkcmd = res.data.data[1].link
                                    this.data[1].link_[2].linkcmd = res.data.data[2].link
                                    this.data[1].link_[3].linkcmd = res.data.data[3].link
                                    this.data[1].link_[4].linkcmd = res.data.data[4].link
                    })
        },
        Shipai(cate2){
                    this.$axios.post(
                    "https://www.3dyunchuang.com/api/test/GetRandCateInfo",
                    this.$qs.stringify({
                        cate:19,    
                    }),    
                    )
                    .then(res => {

                           
                            let len = res.data.data.length;
                            for(let i =0 ;i<len ; i++){
                                  this.data[2].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                  this.data[2].text_h2[i] = res.data.data[i].title
                                  this.data[2].link_[i].codeid = res.data.data[i].ID
                                  this.data[2].link_[i].linkcmd =res.data.data[i].link
                            }

                            // this.data[2].imag[0]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].img+'.'+res.data.data[0].type
                            // this.data[2].imag[1]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[1].img+'.'+res.data.data[1].type
                            // this.data[2].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
                            // this.data[2].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                            // this.data[2].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
              
                          //  this.data[2].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
   
                            //文字
                            // this.data[2].text_h2[0] = res.data.data[0].title
                            // this.data[2].text_h2[1] = res.data.data[1].title
                            // this.data[2].text_h2[2] = res.data.data[2].title
                            // this.data[2].text_h2[3] = res.data.data[3].title
                            // this.data[2].text_h2[4] = res.data.data[4].title
 
                            // this.data[2].text_h2[2] = res.data.data[2].title
                        
                            // id
                            // this.data[2].link_[0].codeid = res.data.data[0].ID
                            // this.data[2].link_[1].codeid = res.data.data[1].ID
                            // this.data[2].link_[2].codeid = res.data.data[2].ID
                            // this.data[2].link_[3].codeid = res.data.data[3].ID
                            // this.data[2].link_[4].codeid = res.data.data[4].ID
                            // this.data[2].link_[2].codeid = res.data.data[2].ID

                            // this.data[2].text_h2[3] = res.data.data[3].title
                            // this.data[2].text_h2[4] = res.data.data[4].title
                            // this.data[2].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                            // this.data[2].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
                            // this.data[2].link_[3].codeid = res.data.data[3].ID
                            // this.data[2].link_[4].codeid = res.data.data[4].ID

                            
   
            })  
        },
        Museum(cate2){
                    this.$axios.post(
                    "https://www.3dyunchuang.com/api/test/GetRandCateInfo",
                    this.$qs.stringify({
                        cate:9,  
                    }),    
                    )
                    .then(res => {


                           let len = res.data.data.length;
                            for(let i =0 ;i<len ; i++){
                                  this.data[3].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                  this.data[3].text_h2[i] = res.data.data[i].title
                                  this.data[3].link_[i].codeid = res.data.data[i].ID
                                  this.data[3].link_[i].linkcmd =res.data.data[i].link
                            }

                            // this.data[3].imag[0]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].img+'.'+res.data.data[0].type
                            // this.data[3].imag[1]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[1].img+'.'+res.data.data[1].type
                            // this.data[3].imag[2]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[2].img+'.'+res.data.data[2].type
   
                            // //文字
                            // this.data[3].text_h2[0] = res.data.data[0].title
                            // this.data[3].text_h2[1] = res.data.data[1].title
                            // this.data[3].text_h2[2] = res.data.data[2].title
                        
                            // // id
                            // this.data[3].link_[0].codeid = res.data.data[0].ID
                            // this.data[3].link_[1].codeid = res.data.data[1].ID
                            // this.data[3].link_[2].codeid = res.data.data[2].ID

                            // this.data[3].text_h2[3] = res.data.data[3].title
                            // this.data[3].text_h2[4] = res.data.data[4].title
                            // this.data[3].imag[3]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[3].img+'.'+res.data.data[3].type
                            // this.data[3].imag[4]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[4].img+'.'+res.data.data[4].type
                            // this.data[3].link_[3].codeid = res.data.data[3].ID
                            // this.data[3].link_[4].codeid = res.data.data[4].ID
   
                     
            })  
        },
         Print(cate2){
                    this.$axios.post(
                    "https://www.3dyunchuang.com/api/test/GetRandCateInfo",
                    this.$qs.stringify({
                        cate:22,  
                    }),    
                    )
                    .then(res => {


                           let len = res.data.data.length;
                            for(let i =0 ;i<len ; i++){
                                  this.data[4].imag[i]  = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[i].img+'.'+res.data.data[i].type
                                  this.data[4].text_h2[i] = res.data.data[i].title
                                  this.data[4].link_[i].codeid = res.data.data[i].ID
                                  this.data[4].link_[i].linkcmd =res.data.data[i].link
                            }

                     
            })  
        }
    },
    mounted(){
        //传展示什么类型
        this.Exhibition_hall("VR展厅")
        this.Booth("VR展位")         
        this.Museum("VR党建文博")  
        this.Shipai("VR实拍")   
        this.Print("VR线上画展")
    },
}
</script>
<style scoped>
ul,li{
    list-style: none;
}
.cennert_bg{
    width: 100%;
    height: 888px;
    background: #142443;
    position: relative;
}
.cennert_op{
    width: 100%;
    height: 100%;
    background: url("../../assets/imges/scheme/cennert_bg.png");
    background-size: 100% 100%;
    opacity: 0.1;
    position: absolute;
    left: 0;
    top: 0;
}

.index_cennert{
    width: 1202px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
}
.index_cennert h2{
    padding-top: 63px;
    text-align: center;
    color: #fff;
    font-weight: 400;
    font-size: 36px;
    font-weight: bold;
}
.desc{
    padding-top: 12px;
    padding-bottom: 60px;
    font-size: 18px;
    color: #ffffff;
    text-align: center
}
.connert_left{
    float: left;
    height: 574px;
    background-color: #2e353e;
    background: #1a2e56;
}
.connert_left li{
    line-height: 75px;
    color: #fff;
    width: 148px;
    height: 75px;
    text-align: center;
    font-size: 14px;
    position: relative; 
}
.connert_left li h4{
    font-weight: normal;
}

.connert_right{
    width: 1031px;
    float: right;
    height: 574px;
}
.connert_left li:last-of-type:after{
    height: 0;
}
.connert_left li:after {
    content: "\0020";
    display: block;
    height: 1px;
    background: #334569;
    overflow: hidden;
    width: 24px;
    transition: 0.5s all;
     position: absolute;
    left: 50%;
    bottom: 7px;
    transform: translateX(-50%);
}
.detailed_footer h4{
    font-size: 16px;
    margin-top: 36px;
    color: #989a99;
    font-weight: normal;
}
.connert_right_top{
    width: 100%;
    height: 333px;
    margin-bottom: 20px;
}
.connert_right_bottom{
    width: 100%;
    height: 220px;
}
.right_top_pop1{
    width: 504px;
    height: 100%;
    float: left;
    position: relative;
    overflow: hidden;
}
.right_top_pop2{
    width: 504px;
    height: 100%;
    float: right;
    position: relative;
    overflow: hidden;
}
.bottom_list{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between
}
.bottom_list li{
    width: 327px;
    height: 100%;
    position: relative;
    overflow: hidden;
}
.box_txt{
    position: absolute;
    bottom: 0px;
    left: 0px;    
    height: 42px;
    width: 100%;
    background: rgba(25,25,25,.5);
    line-height: 42px;
    color: #fff;
}
.box_txt p{
    margin-left: 20px;
    font-size: 14px;
}
.right_top_pop1 img{
    width: 100%;
    height: 100%;
}
.Left_tip{
    position: absolute;
    left: -12px;
    top: 0;
    width: 191px;
    height: 68px;
    background: url("../../assets/imges/hy_lef.png") no-repeat  !important;
    background-size:100% 100%;
    cursor: pointer;
    font-weight: bold!important;
    transition: 0.5s all;
    z-index: 9;
}
.connert_right img{
    width: 100%;
    height: 100%;
    transition: 1s all;
    cursor: pointer;
}
.connert_right img:hover{
    transform: scale(1.2);
}
.mobile_terminal{
    width: 100%;
    height: 170px;
    -webkit-box-shadow: 0px 2px 0 rgba(0,0,0,.1);
    border-radius: 0 0 2px 2px;
    display: none;
}
.mobile_terminal ul{
    width: 100%;
    height: 100%;
    display: flex;
}
.mobile_terminal ul li{
    flex: 1;
    height: 184px;
    text-align: center;
}
.mobile_terminal ul li div{
    width: 100%;
    text-align: center;
    height: 50px;
    margin-bottom: 10px;
}
.mobile_terminal ul li div img{
    width: 50px;
    height: 50px;
}
.mobile_terminal ul li p{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.mobile_terminal ul li span{
    color: #333;
    font-size: .22rem;
    font-weight: 500;
    margin-bottom: .16rem;
}
.application{
    width: 100%;
    height: 100px;
    display: none;
}
.products{
    width: 100%;
    height: 230px;
    display: none;
}
.swiper-container{
    width: 95%;
    height: 200px;
}
.swiper-container img{
    width: 100%;
    height: 100%;
}
#swiper-text{
    color: #fff;
    height: 25px;
    position: absolute;
    z-index: 9999999;
    left: 50%;
    bottom: 20px;
    width:70px;
    border:1px solid #fff;
    border-radius: 10px;
    text-align: center;
    line-height: 25px;
    margin-left: -28px;
    font-weight: normal;
    font-size: 14px;
}
</style>





// WEBPACK FOOTER //
// src/common/scheme/scheme-cennert.vue